import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

const FAMILY_IMG =
  "https://images.unsplash.com/photo-1626984367254-fe8fa5e9c552?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHozfHxoaXNwYW5pYyUyMGZhbWlseSUyMGZpbmFuY2lhbCUyMHBsYW5uaW5nJTIwcmV0aXJlbWVudCUyMHNtaWxlfGVufDB8fHx8MTc5MDY1MjMxOXww&ixlib=rb-4.1.0&q=85";

const testimonials = [
  { name: "María G.", city: "Houston, TX", text: "Pensaba que un seguro de vida era solo un gasto. Ahora tengo protección y mi dinero crece. La asesoría fue clara y en español." },
  { name: "José y Ana R.", city: "Phoenix, AZ", text: "Nos explicaron todo con paciencia. Además usamos el bono de $50 en nuestro seguro de auto. ¡Excelente trato!" },
  { name: "Luis M.", city: "Miami, FL", text: "Llené el formulario y me llamaron el mismo día. Sin presión, solo opciones reales para mi familia." },
];

export const Trust = () => (
  <section className="py-20 lg:py-28 bg-white" data-testid="trust-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.96 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="lg:col-span-5 relative"
      >
        <img
          src={FAMILY_IMG}
          alt="Familia hispana feliz y protegida"
          className="rounded-3xl object-cover w-full h-[420px] lg:h-[520px] shadow-2xl"
        />
        <div className="absolute bottom-6 left-6 right-6 glass rounded-2xl p-4 border border-white/60 shadow-lg">
          <p className="text-xs font-bold tracking-[0.18em] text-growth">PROTECCIÓN · CRECIMIENTO · LEGADO</p>
          <p className="mt-1 text-sm text-navy font-semibold">Protégete a ti y a tu familia hoy y construye tu futuro de la mejor manera.</p>
        </div>
      </motion.div>

      <div className="lg:col-span-7">
        <p className="text-xs font-bold tracking-[0.2em] text-growth uppercase">Testimonios</p>
        <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-navy">
          Lo que dicen las familias que ya dieron el paso.
        </h2>
        <div className="mt-10 grid sm:grid-cols-2 gap-5">
          {testimonials.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className={`rounded-2xl border border-slate-200 bg-[var(--slate-50)] p-6 card-lift ${i === 2 ? "sm:col-span-2" : ""}`}
              data-testid={`testimonial-card-${i + 1}`}
            >
              <Quote className="h-6 w-6 text-brand-blue/40" />
              <blockquote className="mt-3 text-slate-700 leading-relaxed">“{t.text}”</blockquote>
              <figcaption className="mt-4 flex items-center justify-between">
                <div>
                  <p className="font-bold text-navy text-sm">{t.name}</p>
                  <p className="text-xs text-slate-500">{t.city}</p>
                </div>
                <div className="flex text-amber-400">
                  {[...Array(5)].map((_, k) => <Star key={k} className="h-4 w-4 fill-current" />)}
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </div>
  </section>
);
